<template>
  <v-row class="mx-0">
    <v-container
      class="grey lighten-2 the_padding"
      :class="[$vuetify.breakpoint.mdAndUp ? 'p-12':'']"
      fluid
      :style="{backgroundImage: 'url('+`${publicPath}images/imagenes/portada.jpg`+')'}"
      style="background-size: cover;"
    >
      <v-card class="mx-auto resolucion" color="white" tile>
        <v-row class="my-10">
          <v-col sm="12" md="12" xl="12" class="px-md-12">
            <v-form action="payment.php" method="POST" id="paymentForm" style="width: 100%;">
              <v-row class="mx-0" :reverse="$vuetify.breakpoint.smAndDown">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  xl="12"
                  :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 pt-12' : '']"
                >
                  <h1
                    :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
                    class="font-weight-bold text-uppercase mb-4 text-center"
                  >Pago aceptado</h1>
                  <v-col cols="12" class="d-flex align-center justify-center">
                    <v-img
                      :src="`${publicPath}images/iconos/check.png`"
                      alt
                      height="100"
                      width="100"
                      contain
                    ></v-img>
                  </v-col>
                  <p
                    class="title text-center pb-2"
                  >El pago de tu inscripción se ha realizado exitosamente, en breve recibirá sus claves de acceso.</p>
                  <p
                    class="title text-center pb-2"
                  >La ficha de inscripción puedes descargarla en el siguiente botón.</p>
                </v-col>
              </v-row>
              <v-layout
                :row="$vuetify.breakpoint.mdAndUp"
                :column="$vuetify.breakpoint.smAndDown"
                :reverse="$vuetify.breakpoint.smAndDown"
                class="mx-5 text-center"
              >
                <div class="flex-grow-1" v-if="$vuetify.breakpoint.mdAndUp"></div>
                <v-btn
                  href="ficha.docx"
                  rounded
                  large
                  color="accent"
                  target="_blank"
                  class="px-10 mb-5 mr-4"
                >DESCARGAR FICHA</v-btn>
                <v-btn rounded large color="primary" class="px-10 mb-5" href="/">Ir a inicio</v-btn>
                <div class="flex-grow-1" v-if="$vuetify.breakpoint.mdAndUp"></div>
              </v-layout>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-row>
</template>
<style lang="scss" scoped>
.action-img {
  background-size: cover;
}
.action-img-mobile {
  background-size: cover;
  height: 400px;
}
.profile-img {
  background-size: cover;
}
.profile-img-mobile {
  background-size: contain;
  height: 200px;
}
.blue-bg {
  background-color: #111f3c;
}
.the_padding {
  padding-top: 120px;
}
@media (min-width: 601px) and (max-width: 960px) {
  .resolucion {
    max-width: 40vh;
  }
}
@media (min-width: 961px) and (max-width: 1264px) {
  .resolucion {
    max-width: 50vh;
  }
}
@media (min-width: 1265px) and (max-width: 1904px) {
  .resolucion {
    max-width: 150vh;
  }
}
@media (min-width: 1905px) {
  .resolucion {
    max-width: 70vh;
  }
}
</style>
<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  },
  mounted() {
    if(this.$store.state.referenceEmail != null && this.$store.state.referenceEmail != ''){
      var self = this;
      axios
        .post("https://www.informes-uva.tidingo.com/api/create-email-payment", {
          name: self.$store.state.referenceName,
          email: self.$store.state.referenceEmail,
        })
        .then(function (response) {
          self.$store.dispatch("setEmail", '');
          self.$store.dispatch("setName", '');  
        })
        .catch(function (error) {
        });
    }
  }
};
</script>
